import React from 'react';
import { Menu, Box, Typography, Button, Stack, useTheme, TextField, InputAdornment } from '@mui/material';
import { JSEditableInput } from '@shared/ui/common';
import DialogHeader from '@shared/ui/dialog/DialogHeader';

const menuAnchorProps = {
  anchorOrigin: { vertical: 'bottom' as const, horizontal: 'right' as const },
  transformOrigin: { vertical: 'top' as const, horizontal: 'right' as const },
};

interface BulkEditNumberDropdownProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  title: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  onConfirm: () => void;
  suffix?: string;
  placeholder?: string;
  isLoading?: boolean;
}

const BulkEditNumberDropdown: React.FC<BulkEditNumberDropdownProps> = ({
  anchorEl,
  open,
  onClose,
  title,
  label,
  value,
  onChange,
  onConfirm,
  suffix = 'weeks',
  placeholder = '0',
  isLoading = false,
}) => {
  const theme = useTheme();

  return (


    <Menu anchorEl={anchorEl} open={open} onClose={onClose} {...menuAnchorProps}>
      <Box sx={{ p: 0, width: 320 }}>

        <DialogHeader>
          <Typography variant="subtitle2" >
            {title}
          </Typography>
        </DialogHeader>


        <Stack direction="column" gap={1} alignItems="center" justifyContent="flex-start" flex={1} px={3} py={2}>
          <TextField
            autoFocus
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            InputProps={{
              endAdornment: <InputAdornment position="end">{suffix}</InputAdornment>
            }}
            variant="outlined"
            sx={{ minWidth: '100%' }}
          />

        </Stack>
        <Stack direction="row" gap={1} alignItems="center" justifyContent="space-between" flex={1} sx={{ p: 2, borderTop: 1, borderColor: theme.palette.divider }}>

          <Button variant="text" onClick={onClose} disabled={isLoading} >
            Cancel
          </Button>

          <Button variant="contained" onClick={onConfirm} disabled={isLoading} >
            {isLoading ? 'Saving...' : 'Apply'}
          </Button>
        </Stack>

      </Box>
    </Menu>
  );
};
export default BulkEditNumberDropdown;
